module.exports = "/images/francois.png?a84af4e71a676bfc5d8d7f606b6d5566";